import { render, staticRenderFns } from "./RESTCsRes.vue?vue&type=template&id=3f4b2e52&scoped=true&"
import script from "./RESTCsRes.vue?vue&type=script&lang=js&"
export * from "./RESTCsRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4b2e52",
  null
  
)

export default component.exports